export var EPhysicsStatisticsInfo;
(function (EPhysicsStatisticsInfo) {
    EPhysicsStatisticsInfo[EPhysicsStatisticsInfo["C_PhysicsEventCount"] = 0] = "C_PhysicsEventCount";
    EPhysicsStatisticsInfo[EPhysicsStatisticsInfo["FrameClearCount"] = 1] = "FrameClearCount";
    EPhysicsStatisticsInfo[EPhysicsStatisticsInfo["C_PhysicaDynamicRigidBody"] = 2] = "C_PhysicaDynamicRigidBody";
    EPhysicsStatisticsInfo[EPhysicsStatisticsInfo["C_PhysicaStaticRigidBody"] = 3] = "C_PhysicaStaticRigidBody";
    EPhysicsStatisticsInfo[EPhysicsStatisticsInfo["C_PhysicaKinematicRigidBody"] = 4] = "C_PhysicaKinematicRigidBody";
    EPhysicsStatisticsInfo[EPhysicsStatisticsInfo["C_PhysicaCharacterController"] = 5] = "C_PhysicaCharacterController";
    EPhysicsStatisticsInfo[EPhysicsStatisticsInfo["C_PhysicsJoint"] = 6] = "C_PhysicsJoint";
    EPhysicsStatisticsInfo[EPhysicsStatisticsInfo["Count"] = 7] = "Count";
})(EPhysicsStatisticsInfo || (EPhysicsStatisticsInfo = {}));
